import assetsReducer from './redusers/assets/reducers'
import authReducer from './redusers/auth/reducers'
import chartReducer from './redusers/chart/reducers'
import ordersReducer from './redusers/orders/reducers'
import positionsReducer from './redusers/positions/reducers'
import sidebarReducer from './redusers/sidebar/reducers'
import socketsReducer from './redusers/sockets/reducers'
import userReducer from './redusers/user/reducers'

export const appReducer = (
	state = {},
	action
) => {
	if (action.type === 'ROOT_REDUCER_RESET') {
		return {}
	}
	return {
		assets: assetsReducer(state.assets, action),
		auth: authReducer(state.auth, action),
		chart: chartReducer(state.chart, action),
		orders: ordersReducer(state.orders, action),
		positions: positionsReducer(state.positions, action),
		sidebar: sidebarReducer(state.sidebar, action),
		sockets: socketsReducer(state.sockets, action),
		user: userReducer(state.user, action)
	}
}
